module.exports = __webpack_public_path__ + "img/f2d8df897012366240dfa2515dadc4f4_副本.b4a5cbc2.jpg";